import {AxiosError} from 'axios'
import {useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {getContent} from '../../modules/auth/core/_requests'
import ContentEditModal from './Modals/ContentModals/ContentEditModal'
import ContentDeletionModal from './Modals/ContentModals/ContentDeletionModal'
import TabContentBar from './TabContentBars/TabContentBar'
import TabContentTableCategory from './TabContentTables/TabContentTableCategory'

function SelectedContent({id}: any) {
  const intl = useIntl()
  const lang = useLang()
  const navigate = useNavigate()
  const {state}: any = useLocation()
  const page = state?.page || 1
  const rowsPerPage = state?.rowsPerPage || 5

  const [action, setAction] = useState(true)
  const [deleteAction, setDeleteAction] = useState(false)
  const [item, setItem] = useState<any>([])
  const [isChecked, setISChecked] = useState<Array<string>>([])
  const [isCheckedData, setISCheckedData] = useState<Array<string>>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [editData, setEditData] = useState([])

  const getList = async () => {
    try {
      const {data} = await getContent(id, lang)
      setItem(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇  Herhangi Bir Aksiyon Sonrası Listeyi Yenile
  useEffect(() => {
    if (action) {
      getList()
      setISChecked([])
      setISCheckedData([])
      setAction(false)
    }
  }, [action])

  useEffect(() => {
    if (deleteAction) {
      navigate('/management/content', {
        state: {page, rowsPerPage},
      })
    }
  }, [deleteAction])

  function handleChecked(e: any, item: any) {
    const {value, checked}: any = e.target
    if (checked) {
      setISChecked([...isChecked, value])
      setISCheckedData([...isCheckedData, item])
    } else {
      setISChecked(isChecked.filter((item: any) => item !== value))
      setISCheckedData(isCheckedData.filter((item: any) => item !== item))
    }
  }

  function checkedControl(id: string) {
    if (isChecked) {
      if (isChecked.includes(id)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  return (
    <div className=' gx-xl-10 mt-lg-n16 mt-2'>
      <button
        type='button'
        className='btn btn-light mb-2 '
        onClick={() =>
          /* navigate(-1)*/ navigate('/management/content', {
            state: {page, rowsPerPage},
          })
        }
      >
        ❮ {intl.formatMessage({id: 'BACK'})}
      </button>
      <div className='d-flex justify-content-between'>
        <h2 className='mb-8'>{item.contentTitle}</h2>
        <div className='flex-row b-1'>
          <button
            type='button'
            className='btn btn-light square border border-dark  m-2'
            data-bs-toggle='modal'
            data-bs-target='#updateContent_modal'
          >
            Edit
          </button>
          <button
            type='button'
            className='btn btn-light square border border-dark m-2'
            data-bs-toggle='modal'
            data-bs-target='#deleteContent_modal'
          >
            Delete
          </button>
        </div>
      </div>
      <div className='card card-custom'>
        <div className='card-header text-dark'>
          <h3 className='card-title'>Content Details</h3>
          <div className='card-toolbar'></div>
        </div>
        <div className='card-body'>
          <div className='d-flex flex-row flex-column-fluid'>
            <div className='d-flex flex-row-fluid'>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50'>Metadata</span>
                    <span className='text-dark'>{item.metadata}</span>
                  </div>
                </div>

                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50 mt-5'>Spot</span>
                    <span className='text-black'>
                      <div dangerouslySetInnerHTML={{__html: item?.spot}} />
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className='separator my-10'></div>

            <div className='d-flex flex-row-fluid   '>
              <div className='d-flex flex-column'>
                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50'>Release Date</span>
                    <span className='text-dark'>{item.releaseDate}</span>
                  </div>
                </div>

                <div className='d-flex flex-column-fluid'>
                  <div className='d-flex flex-column '>
                    <span className='text-black-50 mt-5'>Create Date</span>
                    <span className='text-black'>{item.createDate}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* */}

      <div className='card card-custom shadow mt-10'>
        <div className='card-header card-header-stretch'>
          <div className='card-toolbar'>
            <ul className='nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0'>
              <li className='nav-item'>
                <a className='nav-link active' data-bs-toggle='tab' href='#kt_tab_pane_7'>
                  Content Category
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='card-body'>
          <div className='tab-content' id='myTabContent'>
            <div className='tab-pane  active' id='kt_tab_pane_7' role='tabpanel'>
              <TabContentBar
                title='Content Category'
                cBTitle='Category'
                isChecked={isCheckedData}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                item={item}
                setAction={setAction}
                editData={editData}
              />
              <div className='separator border-3 my-10'></div>
              <TabContentTableCategory
                searchTerm={searchTerm}
                checkedControl={checkedControl}
                handleChecked={handleChecked}
                action={action}
                id={item.id}
                setEditData={setEditData}
              />
            </div>
          </div>
        </div>
      </div>
      {/*Edit Device Modal */}
      <ContentEditModal editData={item} setAction={setAction} />
      {/*Delete Device Modal */}
      <ContentDeletionModal checkList={item.id} setAction={setDeleteAction} />
    </div>
  )
}

export default SelectedContent
